module.exports = __webpack_public_path__ + "static/media/DATA-SCIENCE-TEAM.1b6d18b9.svg";